module.exports = __webpack_public_path__ + "img/project.58fd9920.jpg";